import clsx from "clsx";
import type { PropsWithChildren } from "react";

import Headline from "~/components/Headline/Headline";

export type FormSectionProps = {
	title?: string;
	className?: string;
};

export const FormSectionGroup: React.FC<PropsWithChildren> = ({ children }) => (
	<div className="flex flex-col gap-6">{children}</div>
);

const FormSection: React.FC<PropsWithChildren<FormSectionProps>> = ({ title, children,className }) => (
	<section className={clsx("flex flex-col gap-2 sm:flex-row sm:justify-between sm:gap-4 sm:border-b sm:pb-6 sm:last:border-0", className)}>
		{title && (
			<Headline type="h5"
					  className="sm:w-32 sm:min-w-32 sm:pt-1 sm:text-xs sm:font-semibold sm:leading-normal sm:tracking-normal sm:text-gray-400">
				{title}
			</Headline>
		)}
		<div className="grow sm:pt-1">{children}</div>
	</section>
);

export default FormSection;
